var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-div',{staticClass:"FormLayout",attrs:{"pl-3":_vm.displayIsMobile || _vm.displayIsTablet,"pr-3":_vm.displayIsMobile || _vm.displayIsTablet,"float-center":"","width-100-percent":""}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }